import InlineReplacement from './base/inline-replacement';
import intermoji from '@intercom/intermoji';
export default InlineReplacement.extend().reopenClass({
  delimiter: /(:[^:\s]+:)$/,
  tryReplacementWithIndex(block, index) {
    if (block.get('config.allowEmoji')) {
      let blockText = block.get('text');
      let textBeforeIndex = blockText.slice(0, index);
      let textBeforeIndexAfterReplacement;
      let match = this.delimiter.exec(textBeforeIndex);
      let startIndex = 0;
      if (match) {
        startIndex = match.index;
        textBeforeIndex = textBeforeIndex.slice(startIndex);
        textBeforeIndexAfterReplacement = intermoji.substituteUnicodeForColonified(textBeforeIndex);
        if (textBeforeIndex !== textBeforeIndexAfterReplacement) {
          blockText = blockText.slice(0, startIndex) + textBeforeIndexAfterReplacement + blockText.slice(index);
          block.set('text', blockText);
          block._updateEntitiesAfterInlineReplacement(startIndex, match[1].length, 2);
        }
      }
    }
    this.delimiter.lastIndex = 0;
  }
});